import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import Icon from 'flow/components/ui-components/Icon';
import { TicketStatus } from 'flow/types/Tickets';

import { STATUS_LABEL_KEYS } from 'flow/components/tickets/State/state-labels';

interface Props {
    statusKey: TicketStatus;
}

const TicketHeaderStateButtonFace = ({ statusKey }: Props) => {
    const { i18next } = useAppContext();

    const iconKey =
        statusKey === 'closed'
            ? 'assignmentCompleteOutlined'
            : 'assignmentOutlined';

    return (
        <>
            <span className="hidden @max-[500px]:inline-flex">
                <Icon iconKey={iconKey} size="0.875rem" />
            </span>
            <span className="line-clamp-1 break-all @max-[500px]:hidden">
                {i18next.t(STATUS_LABEL_KEYS[statusKey])}
            </span>
            <Icon iconKey="arrow_down" />
        </>
    );
};

export default React.memo(TicketHeaderStateButtonFace);
